export default "__VITE_ASSET__B8XyRnty__"